import axios from "axios";

export const state = {
    carts: [],
};

export const getters = {
    carts: state => state.carts,
};

export const mutations = {
    setCarts(state, newValue) {
        state.carts = newValue
    },
};

export const actions = {
    fetchCarts({ commit }) {
        axios.get('/carts').then(res => {
            commit('setCarts', res.data.carts);
            
        })
    },
};
